import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router';

import { Center, Spinner, useToast } from '@chakra-ui/react';

import { ADMIN } from '../constants';
import { useAuth } from '../context/useAuth';
import Layout from '../components/Dashboard/layout';

/**
 * SuperAdminGuard - Route guard that only allows superadmin (ADMIN role) users
 * Redirects other users to appropriate pages based on their role
 */
const SuperAdminGuard = () => {
  const { isAuthenticated, role, loading } = useAuth();
  const toast = useToast();
  const [hasRedirected, setHasRedirected] = useState<boolean>(false);

  useEffect(() => {
    if (isAuthenticated && role !== ADMIN && !hasRedirected) {
      toast({
        position: 'top',
        title: 'アクセス権限がない',
        description: 'このページは管理者のみアクセスできます。',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      setHasRedirected(true);
    }
  }, [isAuthenticated, role, hasRedirected, toast]);

  if (loading) {
    return (
      <Center height="100vh">
        <Spinner size="xl" color="#fca43b" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role !== ADMIN) {
    return <Navigate to="/students" replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default SuperAdminGuard;
